"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADVERT_MAP_V0 = exports.ADVERT_MAP_V1 = void 0;
const guessers_1 = require("./guessers");
exports.ADVERT_MAP_V1 = {
    "id": "id",
    "name": "_$document.label",
    "label": guessers_1.guessLabel,
    "type": guessers_1.guessType,
    "weight": "_$document.meta_data.weight",
    "maxViews": "_$document.meta_data.max_views",
    "isFree": "_$document.meta_data.free",
    "published": "published",
    "archived": "archived",
    "createdAt": "created_at",
    "publishedAt": "pub_date",
    "unpublishedAt": "un_publish_date",
    "openIn": "_$document.meta_data.media_type",
    "source": "_$document.source",
    "author": "_$document.author",
    "logo": "_$document.meta_data.cover_logo",
    "image": "_$document.meta_data.cover_image",
    "video": "_$document.meta_data.post_video",
    "title": "_$document.meta_data.title",
    "subtitle": "_$document.meta_data.subtitle",
    "tagline": "_$document.meta_data.tagline",
    "description": "_$document.meta_data.description",
    "footNote": "_$document.meta_data.foot_note",
    "buttonLabel": "_$document.meta_data.button_label",
    "showReadMore": "_$document.meta_data.tagline_show_more",
    "quiz.link": "_$document.meta_data.quiz.link",
    "quiz.isSurvey": "_$document.meta_data.quiz.survey",
    "quiz.votersCount": "_$document.meta_data.quiz.voters",
    "quiz.votersCountDefault": "_$document.meta_data.quiz.default_voters",
    "quiz.answerButtonLabel": "_$document.meta_data.quiz.answer_button",
    "quiz.validateButtonLabel": "_$document.meta_data.quiz.question_button",
    "quiz.allowMultipleAnswers": "_$document.meta_data.quiz.multiple",
    "quiz.questions": "_$document.meta_data.quiz.answers",
    "story.screens": "screens",
    "story.hightlighted": "story.isHightlighted",
    "search.tabs": "_$document.tabs",
    "search.position": "_$document.position",
    "search.tabPositions": guessers_1.defaultTabPos,
    "sharing.enableLikes": "_$document.meta_data.sharing_options.like_enabled",
    "sharing.enableSharing": "_$document.meta_data.sharing_options.sharing_enabled",
    "sharing.enableBookmarking": "_$document.meta_data.sharing_options.bookmark_enabled",
    "sharing.sharingLink": "_$document.meta_data.share_link",
    "sharing.sharingMessage": "_$document.meta_data.share_message",
};
exports.ADVERT_MAP_V0 = {
    "id": "id",
    "name": "label",
    "label": guessers_1.guessLabel,
    "type": guessers_1.guessType,
    "weight": "meta_data.weight",
    "maxViews": "meta_data.max_views",
    "isFree": "meta_data.free",
    "published": "published",
    "archived": "archived",
    "createdAt": "created_at",
    "publishedAt": "pub_date",
    "unpublishedAt": "un_publish_date",
    "openIn": "meta_data.media_type",
    "logo": "meta_data.cover_logo",
    "image": "meta_data.cover_image",
    "video": "meta_data.post_video",
    "source": "source",
    "author": "author",
    "title": "meta_data.title",
    "subtitle": "meta_data.subtitle",
    "tagline": "meta_data.tagline",
    "description": "meta_data.description",
    "footNote": "meta_data.foot_note",
    "buttonLabel": "meta_data.button_label",
    "showReadMore": "meta_data.tagline_show_more",
    "quiz.link": "meta_data.quiz.link",
    "quiz.isSurvey": "meta_data.quiz.survey",
    "quiz.votersCount": "meta_data.quiz.voters",
    "quiz.votersCountDefault": "meta_data.quiz.default_voters",
    "quiz.answerButtonLabel": "meta_data.quiz.answer_button",
    "quiz.validateButtonLabel": "meta_data.quiz.question_button",
    "quiz.allowMultipleAnswers": "meta_data.quiz.multiple",
    "quiz.questions": "meta_data.quiz.answers",
    "story.screens": "screens",
    "story.hightlighted": "story.isHightlighted",
    "search.tabs": "tabs",
    "search.position": "position",
    "search.tabPositions": guessers_1.defaultTabPos,
    "sharing.enableLikes": "meta_data.sharing_options.like_enabled",
    "sharing.enableSharing": "meta_data.sharing_options.sharing_enabled",
    "sharing.enableBookmarking": "meta_data.sharing_options.bookmark_enabled",
    "sharing.sharingLink": "meta_data.share_link",
    "sharing.sharingMessage": "meta_data.share_message",
};
//# sourceMappingURL=advert.map.js.map